import { RadioProps } from "antd";
import { ConfigProvider } from "antd";
import { StyledRadio, StyledRadioGroup } from "./atom";

export function Radio({ className = "", ...props }: RadioProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: "#FFFFFF",
        },
      }}
    >
      <StyledRadio className={`renderbus-ui--radio ${className}`} {...props} />
    </ConfigProvider>
  );
}

Radio.Group = StyledRadioGroup;
Radio.Button = StyledRadio.Button;
